module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/SingleAlbum-59ba2d2d37a7a52b65041d6c06fed109.webp";